module.exports = __webpack_public_path__ + "img/qilin-stage3-hungry.ec511f96.png";